import { render } from "./TieredMenu.vue?vue&type=template&id=1b667057"
import script from "./TieredMenu.vue?vue&type=script&lang=js"
export * from "./TieredMenu.vue?vue&type=script&lang=js"

import "./TieredMenu.vue?vue&type=style&index=0&id=1b667057&lang=css"
script.render = render

export default script